import { render, staticRenderFns } from "./DemoAnomalyView.vue?vue&type=template&id=375b2c00&scoped=true&"
import script from "./DemoAnomalyView.vue?vue&type=script&lang=ts&"
export * from "./DemoAnomalyView.vue?vue&type=script&lang=ts&"
import style0 from "./DemoAnomalyView.vue?vue&type=style&index=0&id=375b2c00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b2c00",
  null
  
)

export default component.exports